import { Organisation } from 'src/app/interfaces/organisation';
import { readableParagraphsFromEditorPayload } from 'src/app/services/geo-readable-text.util';
import { formatSeoTitle } from 'src/app/services/seo.defaults';
import { buildSeoImageProxyUrl, pickSeoFileInventoryId } from 'src/app/services/seo-image.util';
import { buildOrganizationJsonLd } from 'src/app/services/seo-json-ld.util';
import { PageSeo } from 'src/app/services/seo.model';
import { SeoService } from 'src/app/services/seo.service';

/** Shared SEO payload for public organisation profile (SSR resolver + client). */
export function buildOrganisationPageSeo(org: Organisation): Partial<PageSeo> {
  const strap = org.strapline?.trim();
  const orgDesc = strap
    ? `${org.name} — ${strap} · ChainMart`
    : `Discover ${org.name} on ChainMart — providers and partners in the blockchain space.`;

  const imageFileInventoryId = pickSeoFileInventoryId(
    org.bannerFileInventory,
    org.logoFileInventory,
  );
  const imageUrl = imageFileInventoryId ? buildSeoImageProxyUrl(imageFileInventoryId) : undefined;
  const aboutText = readableParagraphsFromEditorPayload(org.aboutUsBlockJson).join('\n\n').trim();

  return {
    title: formatSeoTitle(org.name),
    description: orgDesc,
    ogDescription: strap
      ? `${org.name} on ChainMart: ${strap}`
      : `Organization profile for ${org.name} on ChainMart.`,
    imageUrl,
    imageFileInventoryId,
    jsonLd: buildOrganizationJsonLd({
      name: org.name,
      description: aboutText ? aboutText.slice(0, 8_000) : orgDesc,
      imageUrl,
      url: '',
    }),
  };
}

export function applyOrganisationPageSeo(seoService: SeoService, org: Organisation): void {
  seoService.applyPageOverride(buildOrganisationPageSeo(org));
}
